import { Icon } from "react-bulma-components";
import { useTranslation } from "react-i18next";
import { SerializedSessionData, shredSession } from "../../../../models/session";
import { ModalProps } from "../../ModalManager";
import { ConfirmModal } from "../ConfirmModal";

export type ConfirmShredSessionModalProps = {
  sessionData: SerializedSessionData
} & ModalProps;

export function ConfirmShredSessionModal({ ...props }: ConfirmShredSessionModalProps) {
  const { t, i18n } = useTranslation();

  const handleOnClick = async () => {
    await shredSession(props.sessionData.boardUid, props.sessionData.uid);
    props.closeModal();
  }

  return (
    <ConfirmModal
      title={t("warning")}
      subtitle={t("modal.shredSession.subtitle")}
      description={t("modal.shredSession.description")}
      closeModal={props.closeModal}
      onConfirm={handleOnClick}
      confirmButtonText={t("modal.button.shred")}
    >
      <Icon color="danger" size="medium">
        <i className="icon-trash is-large" aria-hidden="true"></i>
      </Icon>
    </ConfirmModal>
  )
}
